var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-code', [_c('b-card-title', [_vm._v("Latest Activity")]), _c('div', {
    ref: "scrollContainer",
    staticClass: "log-scrollable",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('b-card', [_c('app-timeline', [_vm._l(_vm.activityLog, function (log, index) {
    var _log$data;
    return _c('app-timeline-item', {
      key: index,
      attrs: {
        "variant": "primary"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
    }, [_c('span', {
      staticClass: "cursor-pointer",
      domProps: {
        "innerHTML": _vm._s(log === null || log === void 0 ? void 0 : (_log$data = log.data) === null || _log$data === void 0 ? void 0 : _log$data.message)
      },
      on: {
        "click": function click($event) {
          return _vm.generateUrl(log);
        }
      }
    }), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatDateTime(log === null || log === void 0 ? void 0 : log.created_at)))])])]);
  }), _vm.loading ? _c('div', {
    staticClass: "text-center my-2"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Loading..."
    }
  })], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }